export enum CLOUD_SERVICES {
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  GOOGLE_PHOTOS = 'googlephotos',
  GOOGLE_DRIVE = 'googledrive',
  REMOTE = 'remote',
}
